import _ from "lodash";

export const isActiveRoute = _.curry((location: object, regex: RegExp) =>
  regex.test(location["pathname"])
);

export const renderTitle = _.curry(
  (location: object, regex: RegExp, title: string) =>
    regex.test(location["pathname"]) ? title : null
);
